//#region src/menu_cover_promo_link_type.ts
var MenuCoverPromoLinkType = /* @__PURE__ */ function(MenuCoverPromoLinkType) {
	MenuCoverPromoLinkType["NoLink"] = "no-link";
	MenuCoverPromoLinkType["MenuItem"] = "menu-item";
	MenuCoverPromoLinkType["MenuPage"] = "menu-page";
	MenuCoverPromoLinkType["MenuSection"] = "menu-section";
	return MenuCoverPromoLinkType;
}(MenuCoverPromoLinkType || {});
//#endregion
export { MenuCoverPromoLinkType };

//# sourceMappingURL=menu_cover_promo_link_type.js.map